export function authHeader() {
  return {
    Accept: "application/json"
  };
}
